import { debounce } from "lodash-es";

import { LABEL_PREVIEW_CONTAINER, RECIPE_TITLE } from "../constants";
import { updateDisplayedDimensions } from "../display";
import { debugLog, getElement } from "../utils";

const DEBOUNCE_DELAY = 50;
const __DEBUG = false;

export const bindLabelPreviewChanges = () => {
  const labelPreviewContainer = getElement(LABEL_PREVIEW_CONTAINER);
  if (!labelPreviewContainer) {
    console.warn(`[bindFormChanges] ${LABEL_PREVIEW_CONTAINER} not found.`);
    return;
  }

  const callback = () => {
    if (__DEBUG) debugLog(`[bindLabelPreviewChanges:callback] Calling updatePreviewDimensions ...`);
    updateDisplayedDimensions();
  };

  const debouncedCallback = debounce(() => {
    if (__DEBUG) debugLog(`[bindLabelPreviewChanges:debouncedCallback] --> callback -->`);
    callback();
  }, DEBOUNCE_DELAY);

  // MutationObserver for Label Preview's DOM structure changes (or changes to any attributes within the container).
  const labelPreviewObserver = new MutationObserver(debouncedCallback);
  labelPreviewObserver.observe(labelPreviewContainer, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  // MutationObserver for recipe title, since it's outside of LABEL_PREVIEW_CONTAINER.
  const recipeTitle = getElement(RECIPE_TITLE);
  if (recipeTitle) {
    const recipeTitleObserver = new MutationObserver(() => {
      if (__DEBUG) debugLog(`[bindLabelPreviewChanges] --> recipeTitleObserver -->`);
      debouncedCallback.cancel();
      callback();
    });
    recipeTitleObserver.observe(recipeTitle, {
      attributes: true,
      attributeFilter: ["style", "class"], // Should be sufficient to capture visibility changes
    });
  }

  // ResizeObserver for dimension changes of the Label Preview container.
  // In a perfect world this might obviate the need for the MutationObserver above,
  // however ResizeObserver is _relatively_ new so we can't rely on it in all users' browsers yet.
  if ("ResizeObserver" in window) {
    const resizeObserver = new ResizeObserver(() => {
      if (__DEBUG) debugLog(`[bindLabelPreviewChanges] --> ResizeObserver -->`);
      debouncedCallback.cancel();
      callback();
    });
    resizeObserver.observe(labelPreviewContainer);
  }

  debugLog(`[bindLabelPreviewChanges] Mutation observers initialized.`);
};
